<p style="font-size: 15px; opacity: 0.8">
    Select the KPIs you would like to track within the Performance Module along with their target
    value. Adjust the selection for Weighted by Loan Amount based on whether you would like to
    consider loan amount when calculating KPI values. If there is a KPI selected you do not wish to
    use, be sure it is removed from all KPI Profiles before you deselect it in this screen.
</p>

<div class="file-upload-log-data-area">
    <custom-mat-table
        [customTableInfo]="customTableInfo"
        (cellClickedEvent)="cellClickedEvent($event)"
        (contentChanged)="contentChanged($event)"
        (inputChangeEvent)="inputChangeEvent($event)"
    ></custom-mat-table>
</div>

<!--<div class="table-container-kpi" style="padding-top: 15px">-->
<!--    <kendo-grid-->
<!--        [loading]="loading"-->
<!--        [data]="grid"-->
<!--        [sortable]="sortable"-->
<!--        [scrollable]="'scrollable'"-->
<!--        [sort]="sort"-->
<!--        (sortChange)="sortChange($event)"-->
<!--        [height]="745"-->
<!--        class="lg-kendo-grid"-->
<!--        #kendoGrid="kendoGrid"-->
<!--        [autoSize]="true"-->
<!--    >-->
<!--        <kendo-grid-column field="isActive" title="" [width]="70">-->
<!--            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">-->
<!--                <p-checkbox-->
<!--                    [(ngModel)]="dataItem.isActive"-->
<!--                    [binary]="true"-->
<!--                    [disabled]="dataItem.isLocked"-->
<!--                    title="{{-->
<!--                        dataItem.isLocked-->
<!--                            ? 'KPI locked because it is used in KPI Profile'-->
<!--                            : dataItem.isActive-->
<!--                            ? 'Enabled'-->
<!--                            : 'Disabled'-->
<!--                    }}"-->
<!--                />-->
<!--            </ng-template>-->
<!--        </kendo-grid-column>-->
<!--        <kendo-grid-column-->
<!--            field="clientKPIDescription"-->
<!--            title="Key Performance Indicator"-->
<!--            [width]="300"-->
<!--        >-->
<!--            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">-->
<!--                {{ dataItem.clientKPIDescription }}-->

<!--                <span style="color: red" *ngIf="isInvalid(dataItem)">-->
<!--                    <p *ngFor="let error of dataItem.errors">{{ error }}</p>-->
<!--                </span>-->
<!--            </ng-template>-->
<!--        </kendo-grid-column>-->

<!--        <kendo-grid-column field="kpiCategory" title="Category" [width]="150"> </kendo-grid-column>-->
<!--        <kendo-grid-column field="bestScore" title="Best Score" [width]="150"> </kendo-grid-column>-->
<!--        <kendo-grid-column field="target" title="Target" [width]="150">-->
<!--            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">-->
<!--                <span style="padding-right: 10px"-->
<!--                    ><i-->
<!--                        class="fas fa-exclamation-circle ng-star-inserted form-error"-->
<!--                        *ngIf="dataItem.targetError"-->
<!--                    ></i-->
<!--                ></span>-->

<!--                <mat-form-field appearance="outline" style="width: 100px; height: 55px">-->
<!--                    <mat-label>Target</mat-label>-->
<!--                    <input-->
<!--                        matInput-->
<!--                        [(ngModel)]="dataItem.target"-->
<!--                        [ngClass]="{ 'form-error': dataItem.targetError }"-->
<!--                        type="number"-->
<!--                    />-->
<!--                </mat-form-field>-->
<!--            </ng-template>-->
<!--        </kendo-grid-column>-->

<!--        <kendo-grid-column field="isWeightedByLA" title="Weighted By Loan Amount" [width]="255">-->
<!--            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">-->
<!--                <p-checkbox-->
<!--                    [(ngModel)]="dataItem.isWeightedByLA"-->
<!--                    [binary]="true"-->
<!--                    [disabled]="dataItem.isWeightedByLADisabled"-->
<!--                />-->
<!--            </ng-template>-->
<!--        </kendo-grid-column>-->
<!--        <kendo-grid-column-->
<!--            field="distributionBtn"-->
<!--            title="Analytics"-->
<!--            [width]="125"-->
<!--            [style]="{ 'text-align': 'centre' }"-->
<!--            [sortable]="false"-->
<!--        >-->
<!--            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">-->
<!--                <div class="analytics-button-area">-->
<!--                    <button-->
<!--                        mat-icon-button-->
<!--                        class="analytic-button"-->
<!--                        [disabled]="!dataItem.ddbiAvailable || !dataItem.isActive"-->
<!--                        (click)="openDistributionAnalyzeDialog(dataItem)"-->
<!--                    >-->
<!--                        <mat-icon-->
<!--                            class="fas fa-chart-line"-->
<!--                            style="font-size: 20px"-->
<!--                            title="{{ getAnalyticIconTooltip(dataItem) }}"-->
<!--                        ></mat-icon>-->
<!--                    </button>-->
<!--                </div>-->
<!--            </ng-template>-->
<!--        </kendo-grid-column>-->
<!--    </kendo-grid>-->
<!--</div>-->
